import React, {Component} from "react"
import {connect} from "react-redux";
import {setInitialData} from "../actions/initialDataActions";
import {Container, Loader, Message} from "semantic-ui-react";
import {getLocalization} from "../utils/localization";
import {setDependentList, setLanguage, setUserInfo} from "../actions/userActions";
import {purgeState} from "../utils/storePersistence";
import {
    AFFILIATE_LINK_EXPIRED_ERROR,
    COVERAGE_DECLINED_PATH,
    EXPIRED_ROUTE,
    languages,
    LINK_EXPIRED_ROUTE,
    RESET_PASSWORD,
    resolveErrorMessage,
    SUCCESS_ROUTE,
    uiFlowResetToken,
    uiFlowUnsubscribe
} from "../utils/common";
import moment from "moment";
import {PrepareAppRequest} from "../services/types";
import {prepareApp} from "../services/services";

const mapStateToProps = (state, ownProps) => {
    const { user, initialData } = state;
    const ratedClass = initialData?.ratedClass;
    const contractTerms = ratedClass?.contractTerms || {};

    const additionalChronic = contractTerms?.chronicBrokerRequested ? contractTerms.chronicCoverageLimit : 0;
    const additionalMental = contractTerms?.mentalBrokerRequested ? contractTerms.mentalCoverageLimit : 0;
    const additionalMaternity = contractTerms?.maternityBrokerRequested ? contractTerms.maternityCoverageLimit : 0;

    return {
        ...ownProps,
        hidePlus: !additionalChronic && !additionalMental && !additionalMaternity,
        lang: user.lang,
        initialData,
    };
};

class PrepareApp extends Component {
    constructor(props) {
        super(props);
        let route = window.location.pathname;
        const isResetPassword = !!route && route.includes(RESET_PASSWORD);
        const isLinkExpired = !!route && route.endsWith(LINK_EXPIRED_ROUTE);
        this.state = {
            loading: true,
            invalidToken: false,
            errorMessage: '',
            isUnsubscribe: false,
            isResetToken: false,
            isResetPassword: isResetPassword,
            isLinkExpired: isLinkExpired,
        }
    }

    componentDidMount() {
        const {isResetPassword, isLinkExpired} = this.state;
        if (!isResetPassword && !isLinkExpired) {
            this.init().then();
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.hidePlus !== this.props.hidePlus){
            this.handleSetHidePlusRoute();
        }
    }

    getRouteBase = () => {
        return window.location.pathname.startsWith('/enrollment') ? '/enrollment' : '';
    }

    handleUnsubscribe = () => {
        this.setState({
            isUnsubscribe: true
        });
        window.location.replace(this.getRouteBase() + "/unsubscribe");
    }

    handleResetToken = () => {
        this.setState({
            isResetToken: true
        });
        window.location.replace(this.getRouteBase() + EXPIRED_ROUTE);
    }

    init = async () => {
        const {initialData} = this.props;

        const {token: storedToken, enrollmentDeclined, isMember} = initialData;
        const urlToken = new URLSearchParams(window.location.search).get("token")

        let missingStoredToken = !storedToken || storedToken.length === 0;
        let missingUrlToken = !urlToken || urlToken.length === 0;

        if (missingUrlToken && missingStoredToken) {
            purgeState();
            this.setState({
                loading: false,
                invalidToken: true,
                errorMessage: "Missing token",
            })
        } else if (!!urlToken) {
            if (!!storedToken && storedToken !== urlToken) {
                purgeState();
                window.location.reload(true);
                return
            }
            this.setState({loading: true});
            try {
                const request = new PrepareAppRequest({token: urlToken})
                const response = await prepareApp(request)
                const {isMember, userName, lastName, dependentList, uiFlow} = response.data;
                if (!response || response.status !== 200) {
                    this.setState({
                        loading: false,
                        invalidToken: true,
                        errorMessage: response.statusText,
                    })
                } else {
                    if (!!isMember) {
                        this.setState({isMember: true});
                        window.location.replace(window.location.origin + "/member");
                        return;
                    }
                    await this.props.dispatch(setInitialData(response.data, urlToken))
                    this.props.dispatch(setUserInfo("SET_FIRST_NAME", userName))
                    this.props.dispatch(setUserInfo("SET_LAST_NAME", lastName))
                    this.props.dispatch(setDependentList(this.mapDependentList(dependentList || [])))
                    this.setState({
                        invalidToken: false,
                        loading: false,
                    });

                    if (!!uiFlow && uiFlow === uiFlowResetToken) {
                        this.handleResetToken();
                        return;
                    }

                    if (!!uiFlow && uiFlow === uiFlowUnsubscribe) {
                        this.handleUnsubscribe();
                        return;
                    }
                }
            } catch (err) {
                const error = resolveErrorMessage(err, "An unexpected error has occurred.");
                if (error === AFFILIATE_LINK_EXPIRED_ERROR) {
                    purgeState();
                    this.redirectToStopScreen(LINK_EXPIRED_ROUTE);
                    return;
                }
                this.setState({
                    loading: false,
                    invalidToken: true,
                    errorMessage: error,
                })
            }
        } else {
            this.setState({
                loading: false,
            });
        }

        enrollmentDeclined && this.redirectToStopScreen(COVERAGE_DECLINED_PATH);
        isMember && this.redirectToStopScreen(SUCCESS_ROUTE);
        this.handleSetHidePlusRoute();
        this.verifyLangIsPresent();
    }

    redirectToStopScreen = (path) => {
        const routePath = this.getRouteBase() + path;
        if(window.location.pathname !== routePath){
            window.location.replace(routePath);
            return;
        }
    }

    handleSetHidePlusRoute = () => {
        const {hidePlus, setHidePlusRoute} = this.props;
        setHidePlusRoute(!hidePlus);
    }

    verifyLangIsPresent() {
        const {lang} = this.props;
        if (!lang) {
            this.props.dispatch(setLanguage(languages.ENGLISH));
        }
    }

    getErrorMessage(errorMessage) {
        switch (errorMessage) {
            case "group class not found":
                return "groupClassNotFound"
            default:
                return "invalidLink"
        }
    }

    mapDependentList(dependentList) {
        return dependentList.map(({ address, id, firstName, middleName, lastName, suffix, birthDate, gender, socialSecurityNumber, relToEmployee, isQualifiedForCoverage }) => ({
            id,
            address: {
              ...address,
              streetAddress: address.street
            },
            firstName,
            middleName,
            lastName,
            suffix,
            birthdate: moment(birthDate).format('MM/DD/YYYY'),
            gender,
            ssn: socialSecurityNumber,
            relationship: relToEmployee,
            isQualifiedForCoverage
          }));
     }

    render() {
        const {
            isResetPassword, isLinkExpired, loading, isMember, isUnsubscribe, isResetToken, errorMessage
        } = this.state
        let content = <React.Fragment>{this.props.children}</React.Fragment>
        if (!isResetPassword && !isLinkExpired) {
            if (loading || isMember || isUnsubscribe || isResetToken) {
                content = <Loader active={true}/>
            } else if (errorMessage.length > 0) {
                const localization = getLocalization(this.props.lang);
                const msg = this.getErrorMessage(errorMessage)
                content = <Container style={{marginTop: '2em'}}><Message style={{textAlign: "center"}}
                    negative>{localization[msg]}</Message></Container>
            }
        }
        return content;
    }
}

export default connect(mapStateToProps)(PrepareApp);
